import {axiosInstance, axiosInstanceWithToken} from '../utils/Client';

export default class LoginService {

    static doLogin = async (credentials) => {
        const authData = {
            credentials: {
                email: credentials.username,
                password: credentials.password
            }
        };
        return await axiosInstance.post('/auth/login/', authData.credentials);
    };

    static checkValidGuid = async (guid) => {
        let url = `/auth/recovery_password/${guid}`;
        return await axiosInstance.get(url);
    };

    static recoveryPassword = async (credentials, guid) => {
        let url = `/auth/recovery_password/${guid}`;
        return await axiosInstance.post(url, credentials);
    }

    static submitEmail = async (email) => {
        return await axiosInstance.post('/auth/lost_password/', {email});
    };

    static logout = async () => {
        return await axiosInstanceWithToken.put('/auth/logout/', {});
    };

    static getPermissions = async (userId) => {
        return await axiosInstanceWithToken.get(
            `/auth/user/permission/list/${userId}/`
        );
    };
}



// WEBPACK FOOTER //
// ./src/services/LoginService.js